/**
 * Validates that all required environment variables are present
 */
export const validateEnvironmentVariables = (): void => {
  const requiredVars = ['VITE_KEYCLOAK_URL', 'VITE_KEYCLOAK_REALM', 'VITE_KEYCLOAK_CLIENT_ID', 'VITE_API_BASE_URL'];

  const missingVars = requiredVars.filter(
    (varName) => typeof import.meta.env[varName] === 'undefined' || import.meta.env[varName] === ''
  );

  if (missingVars.length > 0) {
    throw new Error(
      `Application initialization failed. Missing required environment variables: ${missingVars.join(', ')}`
    );
  }
};
